const info = {
    availability:"#availability",
    phonePreorder:"#phone-preorder",
    numberPreorder:"#number-preorder"
};

export default info;


// WEBPACK FOOTER //
// ./src/js/create/placeholder-info.js